var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSipCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 370,
    viewBox: "0 0 381 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_759_11454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 381,
    height: 370
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 370,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_759_11454)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 294.5,
    cy: 65.5,
    r: 287.5,
    fill: "#B2B2FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 286,
    cy: 73.5,
    rx: 163,
    ry: 163.5,
    fill: "#B0B0FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSipCalculator);
export default __webpack_public_path__ + "static/media/sip-calculator.4c67895900600c7576a562e713dd5761.svg";
export { ForwardRef as ReactComponent };